module.exports = __webpack_public_path__ + "img/tgrw_hom.2b1ec7df.png";